import { useEffect, useReducer } from "react";
import { useLocation } from "react-router-dom";
import { getUserEvents } from "services/event";
import { EVENT_PER_PAGE, FETE_FILTERS } from "utils/constant";
import { getPastDate, getUpcomingDate } from "utils/fete";

const defaultFilters = {
  format: FETE_FILTERS[0].value
};

const initialArgs = {
  currentAndUpcomingEvents: null,
  pastEvents: null,
  upcomingDateFilter: {
    startDate: new Date(),
    endDate: getUpcomingDate(12, 'months'),
  },
  pastDateFilter: {
    endDate: getPastDate(1, 'day'),
    startDate: getPastDate(12, 'months'),
  },
  isEventListAPICall: true,
  is_past_events: true,
  currentAndUpcomingFetesFilter: defaultFilters,
  pastFetesFilter: defaultFilters,
  upcomingPage: 1,
  pastPage: 1,
  pastFeteLoading: true,
  currentFetesLoading: true,
  showRecentActivitiesLoading: true
};

const perPage = EVENT_PER_PAGE

const reducer = (state: any, action: any) => {
  return { ...state, ...action };
};

const useEventListHook = () => {
  const [state, setState] = useReducer(reducer, initialArgs);
  const location = useLocation();

  let currentTeam = JSON.parse(localStorage.getItem("selectedTeam") as string);

  const resetStateToDefaults = () => {
    setState({ ...initialArgs })
  }

  useEffect(() => {
    resetStateToDefaults();
  }, [location.pathname]);

  const getEvents = async ({ start_date, end_date, is_past = false, filters = {}, page = 1 }: any) => {
    currentTeam = JSON.parse(localStorage.getItem("selectedTeam") as string)

    const data: any = await getUserEvents({
      team_id: currentTeam?.currentTeamId,
      start_date,
      end_date,
      is_past: is_past ? is_past : state.is_past_events,
      filters: Object.keys(filters).length > 0 ? filters : state.filters,
      page: page,
      perPage: perPage
    })

    return { data: data.data, total: data?.total }
    // return data;
  }

  useEffect(() => {
    if (state.currentAndUpcomingEvents) {
      (async () => {
        const currentAndUpcomingEvents = await getEvents({
          start_date: state.upcomingDateFilter.startDate,
          end_date: state.upcomingDateFilter.endDate,
          is_past: false,
          page: state.upcomingPage,
          filters: state.currentAndUpcomingFetesFilter
        })
        setState({ ...state, currentAndUpcomingEvents })
      })()
    }
  }, [state.upcomingDateFilter, state.upcomingPage]);

  useEffect(() => {
    if (state.pastEvents) {
      (async () => {
        const pastEvents = await getEvents({
          start_date: state.pastDateFilter.startDate,
          end_date: state.pastDateFilter.endDate,
          is_past: true,
          page: state.pastPage,
          filters: state.pastFetesFilter
        })
        setState({ ...state, pastEvents })
      })()
    }
  }, [state.pastDateFilter, state.pastPage]);

  useEffect(() => {
    if (state.currentAndUpcomingEvents) {
      (async () => {
        const currentAndUpcomingEvents = await getEvents({
          start_date: state.upcomingDateFilter.startDate,
          end_date: state.upcomingDateFilter.endDate,
          filters: state.currentAndUpcomingFetesFilter,
          is_past: false,
          page: state.currentAndUpcomingEvents.upcomingPage
        })
        setState({ ...state, currentAndUpcomingEvents })
      })()
    }
  }, [state.currentAndUpcomingFetesFilter])

  useEffect(() => {
    if (state.pastEvents) {
      (async () => {
        const pastEvents = await getEvents({
          start_date: state.pastDateFilter.startDate,
          end_date: state.pastDateFilter.endDate,
          filters: state.pastFetesFilter,
          is_past: true,
          page: state.pastDateFilter.pastPage
        })
        setState({ ...state, pastEvents })
      })()
    }
  }, [state.pastFetesFilter])

  const updateUserEventCallApiFlag = (flag: boolean) => {
    setState({ ...state, isEventListAPICall: flag, currentFetesLoading: true, pastFeteLoading: true, showRecentActivitiesLoading: true });
  }

  const fetchUserEvents = async () => {
    try {
      const pastEvents = await getEvents({ start_date: getPastDate(12, 'months'), end_date: getPastDate(1, 'day'), is_past: true })
      const currentAndUpcomingEvents = await getEvents({ start_date: new Date(), end_date: getUpcomingDate(12, 'months'), is_past: false })
      setState({ ...state, pastEvents, currentAndUpcomingEvents, isEventListAPICall: false, currentFetesLoading: false, pastFeteLoading: false, showRecentActivitiesLoading: false })
    } catch (error: any) {
      console.log("Error while fetching events =", error);
    }
  };

  return {
    fetchUserEvents,
    setState,
    updateUserEventCallApiFlag,
    ...state,
  };
};

export default useEventListHook;
